import Vue from 'vue';
import Component from 'vue-class-component';
import {SearchSuggest} from '../SearchSuggest';
import vClickOutside from 'v-click-outside';

Vue.use(vClickOutside);

interface ResultItem {
  id: string;
  indexed: string;
  score: number;
  type: string;
  uid: number;
  url: string;
  description?: string;
  subTitle?: string;
  title: string;
  titleExact?: string;
}

interface ResultType {
  id: string;
  name: string;
  count?: number;
}

@Component({
  props: {
    query: String,
    core: String,
    url: String,
    noResults: String,
    resultsForTerm: String,
    searchLabel: String,
  },
})
export default class Results extends Vue {
  query?: string;
  core?: string;
  url?: string;
  noResults?: string;
  resultsForTerm?: string;
  searchLabel?: string;
  types: ResultType[] = [
    {
      id: 'pages',
      name: 'Pages',
    },
    {
      id: 'SLNR\\SlnrProduct\\Domain\\Model\\Product',
      name: 'Product',
    },
    {
      id: 'SLNR\\SlnrNews\\Domain\\Model\\Solution',
      name: 'Solution',
    },
    {
      id: 'SLNR\\SlnrNews\\Domain\\Model\\Software',
      name: 'Software',
    },
    {
      id: 'SLNR\\SlnrNews\\Domain\\Model\\News',
      name: 'News',
    },
    {
      id: 'SLNR\\SlnrEvent\\Domain\\Model\\Event',
      name: 'Events',
    },
    {
      id: 'SLNR\\SlnrJobs\\Domain\\Model\\Jobs',
      name: 'Jobs',
    },
    {
      id: 'SLNR\\SlnrArticle\\Domain\\Model\\Article',
      name: 'Article',
    },
  ];

  $refs!: {
    input: HTMLFormElement,
    suggestList: HTMLUListElement,
  };
  mutatedQuery: string = '';
  resultList: ResultItem[] = [];
  currentFilter = 'all';

  mounted() {
    this.resultList = [];
    if (this.query !== null && this.query !== undefined && this.query !== '') {
      this.mutatedQuery = this.query;
      this.search(null);
    }
  }

  setFilter(newFilterId: string) {
    this.currentFilter = newFilterId;
  }

  setFilterCounts() {
    let counts = [];
    // generate array to sum up counts
    [].forEach.call(this.types, (type: ResultType) => {
      type.count = 0;
      counts[type.id] = 0;
    });
    // loop through resultList and count elements
    [].forEach.call(this.resultList, (result: ResultItem) => {
      counts[result.type] += 1;
    });
    // save counts in types array
    [].forEach.call(this.types, (type: ResultType) => {
      type.count = counts[type.id];
    });
  }

  get filteredItems(): ResultItem[] {
    if (this.currentFilter === 'all') {
      return this.resultList;
    } else {
      return this.resultList.filter(item => {
        return item.type === this.currentFilter;
      });
    }
  }

  clearInput() {
    this.mutatedQuery = '';
    if (this.$refs.input) {
      this.$refs.input.focus();
    }
  }

  hideSuggestList(e) {
    if (!this.$refs.suggestList.classList.contains('hide')) {
      this.$refs.suggestList.classList.add('hide');
    }
  }

  async search(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    let url = window.location.href;
    url = url.substring(0, url.indexOf('?'));
    history.pushState({}, '', `${url}?query=${this.mutatedQuery}`);
    let results = await this.getSearchResult();
    this.resultList = [];
    [].forEach.call(results, (result) => {
      this.resultList.push(result);
    });
    this.currentFilter = 'all';
    this.setFilterCounts();
  }

  private async getSearchResult() {
    const response = await fetch(`${this.url}?core=${this.core}&query=${this.mutatedQuery}`, {
      method: 'get',
    });

    if ((response.status >= 200 && response.status < 300) && !response.redirected) {
      return await response.json();
    }

    return {};
  }

  private  async addSearchSuggestions() {
    new SearchSuggest().triggerSearchRequest(this.$refs.input, this.$refs.suggestList);
  }
}
